import axios from 'axios';

export async function getSubscribingCampaigns(campaignId, stepId) {
  const {data} = await axios.get(
    `/api/?entity=campaigns&action=getSubscribingCampaigns&campaignId=${campaignId}&stepId=${stepId}`
  );

  return data.data;
}
